import * as axiosService from "../axiosService";


export const getOrderList = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/GetOrderList`,payload);
};

export const getOrderFilterMasterData=(orderType)=>{
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/GetOrderFilterMasterData?type=${orderType}`);
}

export const getOrderDetails = (orderId,languageISOCode) => {
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/GetOrderDetails?orderNumber=${orderId}&languageISOCode=${languageISOCode ? languageISOCode:"en"}`);
};

export const getStatusList =(orderId, tripId,languageISOCode)=>{
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/GetStatusList?orderNumber=${orderId}&tripId=${tripId}&languageISOCode=${languageISOCode ? languageISOCode:"en"}`);
}

export const changeTripStatus = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/ChangeTripStatus`,payload);
};

export const reUploadTripStatusDocument = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/ReUploadTripStatusDocument`,payload);
};

export const getLineItemsDocumentDetails = (orderId, tripId) => {
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/GetLineItemsDocumentDetails?orderNumber=${orderId}&tripId=${tripId}`);
};

export const addLineItemDocuments =(payload)=>{
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + '/Order/SaveLineItemDocuments', payload);
}

export const reUploadTripStatusDocuments =(payload)=>{
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + '/Order/ReUploadTripStatusDocument', payload);
}

export const deleteTripStatusDocuments =(payload)=>{
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + '/Order/DeleteTripStatusDocument', payload);
}


export const reUploadLineItemDocuments =(payload)=>{
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + '/Order/ReuploadLineItemDocuments', payload);
}

export const deleteLineItemDocuments =(payload)=>{
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + '/Order/DeleteLineItemDocuments', payload);
}

export const onTripTruckTrackingList =(pageNumber,pageSize)=>{
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Order/OnTripTruckTrackingList?pageNumber=${pageNumber}&pageSize=${pageSize}`);
}


export const postStatusDocUpdate =(payload)=>{
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + '/Order/PostStatusDocUpdate', payload);
}
